import React from "react"

const LABEL    = "block text-[11px] uppercase tracking-wider font-medium text-slate-500 mb-1"
const INPUT    = "w-full h-9 px-3 rounded-md border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-400 transition"
const Required = ({ required }) => (required ? <span className="text-rose-500"> *</span> : null)

const Field = ({ field, value, onChange }) => {
  const set = next => onChange(field.property_field_blueprint_id, next)

  if (field.field_type === "sub_title") {
    return <div className="md:col-span-2 xl:col-span-4 text-[13px] font-semibold text-slate-800">{field.title}</div>
  }

  if (field.field_type === "boolean") {
    return (
      <label className="flex items-center gap-2 text-[12.5px] text-slate-700 mt-5">
        <input type="checkbox" className="h-4 w-4 rounded border border-slate-300" checked={!!value} onChange={event => set(event.target.checked)} />
        {field.title}<Required required={field.required} />
      </label>
    )
  }

  return (
    <div>
      <label className={LABEL}>{field.title}<Required required={field.required} /></label>
      {field.field_type === "string"   && <input type="text" className={INPUT} value={value || ""} onChange={event => set(event.target.value)} />}
      {field.field_type === "date"     && <input type="date"   className={INPUT} value={value || ""} onChange={event => set(event.target.value)} />}
      {field.field_type === "integer"  && <input type="number" step="1"    className={INPUT} value={value || ""} onChange={event => set(event.target.value)} />}
      {field.field_type === "float"    && <input type="number" step="0.01" className={INPUT} value={value || ""} onChange={event => set(event.target.value)} />}
      {field.field_type === "link_url" && <input type="url"    className={INPUT} value={value || ""} onChange={event => set(event.target.value)} />}
      {field.field_type === "options"  && (
        <select className={`${INPUT} bg-white`} value={value || ""} onChange={event => set(event.target.value)}>
          <option value="">—</option>
          {(field.options || []).map(option => <option key={option} value={option}>{option}</option>)}
        </select>
      )}
    </div>
  )
}

const PropertyFieldsSection = ({ fields, values, onChange }) => {
  if (!fields || fields.length === 0) return null
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      {fields.map(field => (
        <Field key={field.property_field_blueprint_id} field={field} value={values[field.property_field_blueprint_id]} onChange={onChange} />
      ))}
    </div>
  )
}

export default PropertyFieldsSection
